module.exports = __webpack_public_path__ + "img/img33.94c6bc53.jpg";